import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { Caption } from '../caption/caption'
import styles from './file-help-text.module.scss'
import { useFile } from './use-file'

export type FileHelpTextElement = HTMLParagraphElement
export type FileHelpTextProps = HTMLAttributes<FileHelpTextElement>

const FileHelpText = forwardRef<FileHelpTextElement, FileHelpTextProps>(function FileHelpText(
  props,
  forwardedRef
) {
  const { className, children, ...rest } = props

  const { selected, error } = useFile()
  const classes = classNames(
    styles.root,
    {
      [styles.selected]: selected,
      [styles.error]: error,
    },
    className
  )

  const errorMessage = children ?? 'Ocorreu um erro inesperado'

  return (
    <Caption {...rest} className={classes} ref={forwardedRef} asChild>
      <p>{error ? errorMessage : children}</p>
    </Caption>
  )
})

export default FileHelpText
